import React from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate } from 'react-router-dom';

const ThankYou = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ bgcolor: 'background.default', py: 8, minHeight: '80vh', display: 'flex', alignItems: 'center' }}>
      <Container maxWidth="md">
        <Box 
          className="glass-effect"
          sx={{ 
            textAlign: 'center', 
            p: 6,
            borderRadius: '20px',
            background: 'linear-gradient(135deg, rgba(255, 107, 107, 0.1) 0%, rgba(255, 217, 61, 0.2) 100%)',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.3)',
          }}
        >
          <CheckCircleIcon 
            sx={{ 
              fontSize: 80, 
              color: 'success.main',
              mb: 3
            }} 
          />
          <Typography 
            variant="h2" 
            className="gradient-text"
            gutterBottom
          >
            Thank You!
          </Typography>
          <Typography 
            variant="h5" 
            color="text.secondary"
            sx={{ mb: 4 }}
          >
            Your order has been successfully placed. You will receive a confirmation email shortly.
          </Typography>
          <Box sx={{ mt: 4, display: 'flex', gap: 2, justifyContent: 'center' }}>
            <Button 
              variant="contained" 
              onClick={() => navigate('/products')}
              sx={{
                background: 'linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%)',
                color: 'background.default',
                '&:hover': {
                  background: 'linear-gradient(135deg, var(--primary) 20%, var(--secondary) 80%)',
                }
              }}
            >
              Continue Shopping
            </Button>
            <Button 
              variant="outlined" 
              onClick={() => navigate('/')}
              sx={{
                borderColor: 'var(--primary)',
                color: 'var(--primary)',
                '&:hover': {
                  borderColor: 'var(--secondary)',
                  color: 'var(--secondary)',
                }
              }}
            >
              Back to Home
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default ThankYou;
